import {useRef} from 'react';

export function counter() {
  const countRef = useRef(0);

  const sum = () => {
    countRef.current += 1;
    return countRef.current;
  };

  const sub = () => {
    countRef.current -= 1;
    return countRef.current;
  };

  const reset = () => {
    countRef.current = 0;

    return countRef.current;
  };

  const setInitialValue = (initialValue: number) => {
    countRef.current = initialValue;

    return countRef.current;
  };

  const total = () => countRef.current;

  return {
    sum,
    sub,
    reset,
    setInitialValue,
    total,
  };
}
